"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[7233],{

/***/ 10698:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69541);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83913);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50556);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66226);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91339);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1041);








const LogoLink = (props)=>{
    const { className, to: customLink, color } = props;
    const { subscription } = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useSubscription */ .mU)();
    const defaultLink = subscription?.hasNeverSubscribed === false ? links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.main : cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.logoRedirectUrl) || links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home;
    const to = customLink === undefined ? defaultLink : customLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: className,
        to: to,
        color: color,
        onClick: ()=>{
            (0,analytics__WEBPACK_IMPORTED_MODULE_7__/* .track */ .j)("Scentbird logo click");
        }
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LogoLink);


/***/ }),

/***/ 84473:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17696);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73358);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31627);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24959);






const NavItem = (props)=>{
    const { className, to, href, toTab, title, label, exclusiveLabel, withArrow, content, style, color, hoverColor, activeColor, labelColor = "gold-50", isActive, onClick, closeNav, "data-testid": dataTestId } = props;
    const isLabelVisible = Boolean(label);
    const isExclusiveLabelVisible = Boolean(exclusiveLabel);
    const handleClick = (event)=>{
        if (typeof closeNav === "function") {
            closeNav();
        }
        if (typeof onClick === "function") {
            onClick(event);
        }
    };
    const itemClassNames = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, {
        [`text-${color}`]: color && !isActive,
        [`hover:text-${hoverColor}`]: hoverColor,
        [`text-${activeColor}`]: activeColor && isActive,
        [`text-${style}`]: style,
        "cursor-pointer": !isActive
    });
    const renderContent = ()=>{
        if (content) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: content
            });
        }
        const formattedTitle = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            value: title,
            html: true
        });
        if (isExclusiveLabelVisible) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "flex items-center",
                children: [
                    formattedTitle,
                    exclusiveLabel
                ]
            });
        }
        if (isLabelVisible) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    formattedTitle,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        className: "ml-4 inline-block w-0",
                        message: label,
                        style: "eye3",
                        color: labelColor,
                        tag: "sup"
                    })
                ]
            });
        }
        if (withArrow) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    formattedTitle,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        name: "other/long-arrow-right"
                    })
                ]
            });
        }
        return formattedTitle;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: itemClassNames,
        to: to,
        href: href,
        toTab: toTab,
        "data-testid": dataTestId,
        onClick: handleClick,
        children: renderContent()
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NavItem);


/***/ }),

/***/ 8323:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    perfumes: {
        en: "Perfumes"
    },
    allPerfumes: {
        en: "All perfumes"
    },
    bestsellers: {
        en: "Best sellers"
    },
    pom: {
        en: "Perfume of the Month"
    },
    com: {
        en: "Cologne of the Month"
    },
    clean: {
        en: "Clean"
    },
    exclusive: {
        en: "Exclusive"
    },
    collections: {
        en: "Collections"
    },
    colognes: {
        en: "Colognes"
    },
    allColognes: {
        en: "All colognes"
    },
    newArrivals: {
        en: "New arrivals"
    },
    referral: {
        en: "Invite your friends and get a free scent"
    },
    newReferral: {
        en: `
      You have
        <span class="{freeFragranceClassName}">
          <span class="rounded-full text-center inline-flex items-center justify-center w-s18 h-s18 text-[11rem]/[18rem] font-bold font-tt-norms-pro {spanClassName}">
            {available}
          </span>
          free {available, plural, one {fragrance} other {fragrances}}
        </span>
      to give away
    `
    },
    track: {
        en: "Track your order"
    },
    queue: {
        en: "Manage your fragrances"
    },
    makeup: {
        en: "Makeup"
    },
    shop: {
        en: "Shop"
    },
    shopAll: {
        en: "Shop all"
    },
    discover: {
        en: "Discover"
    },
    memberPerks: {
        en: "Member perks"
    },
    gifts: {
        en: "Gift Guide"
    },
    holidayGifts: {
        en: "Holiday Gifts"
    },
    holidayGiftsMothersDay: {
        en: "Mother’s Day Gifts"
    },
    holidayGiftsFathersDay: {
        en: "Father’s Day Gifts"
    },
    exclusives: {
        en: "Gift guide exclusives"
    },
    allGifts: {
        en: "All Gifts"
    },
    giftSubscription: {
        en: "Gift Subscription"
    },
    coarPerfumeGiftSets: {
        en: "COAR Perfume Gift Sets"
    },
    coarCologneGiftSets: {
        en: "COAR Cologne Gift Sets"
    },
    coarShopPage: {
        en: "Confessions&nbsp;of&nbsp;a&nbsp;Rebel"
    },
    sbGiftSets: {
        en: "Scentbird gift sets"
    },
    giftSetsPage: {
        en: "Discovery & Gift Sets"
    },
    giftSets: {
        en: "Gift Sets"
    },
    holidayBoxes: {
        en: "Holiday boxes"
    },
    giftCard: {
        en: "Gift Card"
    },
    giftBundles: {
        en: "Gift bundles"
    },
    mySubscription: {
        en: "My subscription"
    },
    beauty: {
        en: "Beauty"
    },
    scentbird: {
        en: "Scentbird"
    },
    edit: {
        en: "The Edit"
    },
    fullSizeFragrances: {
        en: "Full-size fragrances"
    },
    scentbirdCases: {
        en: "Scentbird cases"
    },
    bathBody: {
        en: "Bath & Body"
    },
    accessories: {
        en: "Accessories"
    },
    samples: {
        en: "1.5 mL samples"
    },
    travelSizeFragrances: {
        en: "Travel-size fragrances"
    },
    candlesHomeScents: {
        en: `Candles&nbsp;&&nbsp;Home&nbsp;scents`
    },
    scentProfile: {
        en: "Scent profile"
    },
    fragranceFamilies: {
        en: "Fragrance family library"
    },
    allBrands: {
        en: "All brands"
    },
    careers: {
        en: "Careers"
    },
    press: {
        en: "For the press"
    },
    lastMinuteAddons: {
        en: "Last minute add-ons"
    },
    caseSubscription: {
        en: "Case subscription"
    },
    candleSubscription: {
        en: "Candle Club"
    },
    drift: {
        en: "Drift"
    },
    driftSubscription: {
        en: "Car Scent Club by Drift"
    },
    buyYourQueue: {
        en: "Buy your queue and save"
    },
    privateSale: {
        en: "Private sale"
    },
    referralProgram: {
        en: 'Give a free scent, <span class="text-gold-30">get a free scent</span>'
    },
    aboutScentbird: {
        en: "About  scentbird"
    },
    support: {
        en: "Help & Support"
    },
    aboutUs: {
        en: "About us"
    },
    featuredBrand: {
        en: "Featured brand"
    },
    fomArchive: {
        en: "Fragrance of the Month archive"
    },
    scentWorldPodcast: {
        en: "Scent World podcast"
    },
    driftEcommercePromo: {
        en: "Car&nbsp;scents&nbsp;by&nbsp;Drift"
    },
    scentBlog: {
        en: "Scent blog"
    },
    membership: {
        en: "Your membership"
    },
    orderHistory: {
        en: "Order tracking & history"
    },
    manageSubscription: {
        en: "Manage subscription"
    },
    upgrade: {
        en: "Upgrade your subscription"
    },
    subscribe: {
        en: "Subscribe to Scentbird"
    },
    account: {
        en: "Your account"
    },
    billingInfo: {
        en: "Billing information"
    },
    shippingInfo: {
        en: "Shipping information"
    },
    personalInfo: {
        en: "Personal details"
    },
    reviews: {
        en: "Ratings & Reviews"
    },
    logoff: {
        en: "Log out"
    },
    aria: {
        profileButton: {
            en: "open profile menu"
        }
    },
    labels: {
        subscribed: {
            en: "You're subscribed!"
        },
        newAtScentbird: {
            en: "New at scentbird"
        },
        new: {
            en: "New!"
        },
        sale: {
            en: "Sale!"
        }
    },
    notesLibrary: {
        en: "Notes library"
    },
    scentbirdSelect: {
        en: "Scentbird Select"
    },
    scentHoroscope: {
        en: "Scent Horoscope"
    },
    upgrade2Scents: {
        en: "2 Scents a&nbsp;Month"
    },
    upgradeGet2Scents: {
        en: "Get 2 Scents a&nbsp;Month"
    },
    scentbirdAcademy: {
        en: "Scentbird Academy with&nbsp;Jo&nbsp;Malone&nbsp;CBE"
    },
    sale50: {
        en: "Sale! Up to 50% off"
    },
    giftsUnder50: {
        en: "Gifts under $50"
    },
    perfumeSubscription: {
        en: "Perfume subscription"
    },
    recommendedForYou: {
        en: "Recommended for You"
    }
});


/***/ }),

/***/ 25551:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47361);
/* harmony import */ var compositions_LogoLink_LogoLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10698);
/* harmony import */ var compositions_Footer_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25413);





const MinimalLayout = (props)=>{
    const { children, logoLink, withoutHeader, withFooter } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex min-h-full flex-col",
        children: [
            !withoutHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: isMobile ? "pt-24 pb-8 text-center" : "pt-48 pb-16 text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_LogoLink_LogoLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    to: logoLink,
                    color: "black"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                id: "main",
                className: "flex-auto",
                children: children
            }),
            withFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_Footer_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MinimalLayout);


/***/ })

}]);